// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
import { Http, HttpCustomStructure } from 'app_utils/http'
import { I18nUtil } from 'app_utils/i18n'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import utilities
// @end

// @import types
import {IFetchActivityCalendar} from 'app_types/campus/academic/activityCalendarTypes'
import {IFetchActivitySummary, IFetchCourseActivitySummary} from 'app_types/campus/academic/activitySummaryTypes'
import {IFetchNotesAchieved} from 'app_types/campus/academic/notesAchievedTypes'
// @end

class CourseActivityService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  getActivityTags = () => {
    return [
      { key: 'delivered', label: this.i18nUtil.getTranslate('modules.activity_details.tags.delivered'), color: '#00BB7E' },
      { key: 'pending', label: this.i18nUtil.getTranslate('modules.activity_details.tags.pending'), color: '#FC4C02' },
      { key: 'not_enabled', label: this.i18nUtil.getTranslate('modules.activity_details.tags.not_enabled'), color: '#FFD100' },
      { key: 'not_delivered', label: this.i18nUtil.getTranslate('modules.activity_details.tags.not_delivered'), color: '#000000' },
    ]
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  fetchActivityCalendar = async (params: any) => {
    this.refreshAuthToken()

    // moodle ID of current user
    let user = this.storeObject?.getState().auth?.user?.data
    params.userID = user.moodle.moodle_id

    let responseData: IFetchActivityCalendar

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/calendarEvents`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  fetchActivitySummary = async (params: any) => {
    this.refreshAuthToken()

    let responseData: IFetchActivitySummary

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/course/fetch-courses`, // TODO: Cambiar URL
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  fetchActivitySummaryStats = async (params: any, options: { showError: boolean } = { showError: true }) => {
    this.refreshAuthToken()

    let responseData: IFetchCourseActivitySummary
    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/completionstatus/summary`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      if (options && options.showError) this.screenNotification.fire(responseData)
    }

    return false
  }

  fetchNotesAchieved = async (params: any) => {
    this.refreshAuthToken()

    let user = this.storeObject?.getState().auth?.user?.data
    params.userID = user.moodle.moodle_id

    let responseData: IFetchNotesAchieved

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/grades`, // TODO: Cambiar URL
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }


}

export default CourseActivityService
